import { useMemo } from "react";
import { IRevenueData, RevenueFilterState } from "./ConsumptionRevenueTab.interfaces";

export const useRevenueFilters = (
  data: IRevenueData | undefined,
  currentFilter: RevenueFilterState,
  selectedRefs: {
    families: string[];
    services: string[];
    products: string[];
  },
  filterVersion: number
) => {
  return useMemo(() => {
    if (!data?.revenueList) return [];
    const now = new Date();
    const twelveMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 11, 1);

    let filtered = data.revenueList.filter((item) => {
      const billingDate = new Date(item.billingMonth);
      return billingDate >= twelveMonthsAgo && billingDate <= now;
    });

    if (currentFilter.filterKey && currentFilter.value) {
      // Here compiler knows filterKey is RevenueFilterableKey
      const { filterKey, value } = currentFilter;
      filtered = filtered.filter((item) => String(item[filterKey]).trim() === value.trim());
    }

    filtered = filtered.filter(
      (item) =>
        (selectedRefs.families.length === 0 || selectedRefs.families.includes(item.serviceFamily.trim())) &&
        (selectedRefs.services.length === 0 || selectedRefs.services.includes(item.serviceName.trim())) &&
        (selectedRefs.products.length === 0 || selectedRefs.products.includes(item.acrProductName.trim()))
    );
    return filtered;
  }, [data, currentFilter, selectedRefs, filterVersion]);
};
